module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/battery-half-d8ca99a8dbb481f944b06e03018f9201.svg";